export default __webpack_public_path__ + "static/media/cover_big.cec85932.jpg";